<div class="filter_competitor tw-flex  tw-items-center" [hidden]="util.isMobile()">
  <div class="label_filter">{{'shared.filters.competitors.title' | translate }}</div>
  <div class="filter">
    <div class="custom-select-wrapper">
      <select 
        class="custom-select"
        [(ngModel)]="selected"
        (ngModelChange)="selectCompetitor()">
        <option *ngFor="let competitor of competitors" [ngValue]="competitor.id">
          {{competitor.name}}
        </option>
      </select>
    </div>
  </div>
</div>


